import {Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DropdownModel } from '../dropdown.model';

@Component({
    selector: 'abw-dropdown-result',
    templateUrl: './dropdown-result.component.html',
    styleUrls: ['./dropdown-result.component.scss']
})
export class DropdownResultComponent implements OnChanges {
	@Input() model: DropdownModel;
    @Input() value: any;
    matchedRow: any = null;

    constructor(
    ) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!!changes.value && !!changes.value.currentValue && !!this.model && !!this.model.datas) {
            this.matchedRow = this.model.datas.find(d => d[this.model.valueField] == this.value);
        }
    }

    ngOnInit() {
    }
}